import React, { useMemo } from 'react'
import { isArray, values, isString, isNumber } from 'lodash-es'
// import Render from '../inline-renders'

// render调用render会造成页面卡顿，暂时先用简单方法实现
// 为了实现远洋大表指标合并的需求添加的这个组件，但是可能有其他更好的方法
const ProductRenders = function ({ rowData, value, fields }) {
  const finalValue = useMemo(() => {
    return (value || []).reduce((total, item) => {
      if (isArray(item)) {
        const arr = item.map((v) => {
          return v.title || v.name || v.label
        })
        if (arr.length) {
          total.push(arr.join(','))
        }
      }
      if (isString(item) || isNumber(item)) {
        total.push(item)
      }
      return total || []
    }, [])
  }, [])

  const valueSlugs = useMemo(() => {
    const obj = {}
    const slugs = fields.map((v) => v.slug)
    slugs.forEach((s, index) => {
      if (finalValue[index] || index === 0) {
        obj[s] = finalValue[index]
      }
    })
    return values(obj)
  }, [rowData])

  return (
    <div className="w-full flex flex-nowrap overflow-hidden">
      {valueSlugs.map((item, i) => {
        return (
          <span>
            {item}
            {i === 0 && valueSlugs.length - 1 > 0 ? <span>(</span> : null}
            {i !== 0 && i !== valueSlugs.length - 1 ? <span>,</span> : null}
            {i === valueSlugs.length - 1 && valueSlugs.length - 1 > 0 ? (
              <span>)</span>
            ) : null}
          </span>
        )
      })}
    </div>
  )
}

export default ProductRenders
